import { DEFAULT_ID } from '@usas/ui-web/utils/Constants';

export const localValidate = (formState) => {
  let errors = {};

  // Step Status
  if (formState.stepStatus === DEFAULT_ID) {
    errors.stepStatus = 'New Status is required';
  } else if (formState.stepStatus === formState.currentStatus) {
    errors.stepStatus = 'New Status cannot be the same as Current Status';
  }

  // Step Notes
  if (formState.displayStepNotes === true) {
    if (!formState.stepNotes) {
      errors.stepNotes = 'Notes is required';
    } else if (formState.stepNotes.length > 8000) {
      errors.stepNotes = 'Notes cannot exceed 8000 characters';
    }
  }

  return errors;
};

const GroupMemberWorkflowModalValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
}

export default GroupMemberWorkflowModalValidation;